<ng-container *ngIf="isLoaded; else loaderBlock">
  <div
    class="landing"
    *transloco="let t">
    <div
      class="landing_hero"
      appBackgroundBranded>
      <div class="landing_hero_main __wide">
        <!-- Registration form -->
        <div class="fb-panel __landing">
          <h2 class="register-user_title">{{ registrationPageBrandingTexts.headingText }}</h2>
          @if (!noWelcomeTextFt()) {
            <span class="register-user_welcome-text">{{ registrationPageBrandingTexts.welcomeText }}</span>
          }

          <!-- Request Registration email -->
          <form
            class="register-user_request-email-form"
            [formGroup]="invitationEmailForm"
            (ngSubmit)="requestRegistrationEmail()"
            novalidate>
            <!--Your Email-->
            <div class="form-group">
              <div class="form-control-labelled">
                <input
                  type="email"
                  class="form-control"
                  [ngClass]="{ 'ng-not-empty': emailControl.value.length }"
                  autocomplete="off"
                  id="requestInvitationEmail"
                  name="email"
                  formControlName="email" />
                <label
                  class="form-control-labelled_label__no-star"
                  for="requestInvitationEmail"
                  >{{ t('auth.your-email') }}</label
                >
              </div>
            </div>

            <div
              class="message __error text-xsmall"
              role="alert">
              <ng-container *ngIf="emailControl.invalid && emailControl.dirty">
                <ng-container *ngIf="emailControl.errors.required">{{ t('common.enter-email') }}</ng-container>
                <ng-container *ngIf="emailControl.errors.fbInvalidEmail">{{
                  t('common.enter-valid-email')
                }}</ng-container>
              </ng-container>
              <div
                *ngIf="isDomainBlocked(registrationLink.domains, emailControl.value) && emailControl.valid"
                [innerHTML]="
                  t('registration.user.invalid-domain', {
                    validDomains: allowedDomainsAsList(registrationLink.domains)
                  })
                "
                style="margin-bottom: -8px"></div>
            </div>

            <!--Register button -->
            <div class="form-group">
              <button
                class="btn __l __block __height-l"
                type="submit"
                [disabled]="isInProgress"
                ngPreserveWhitespaces>
                <i
                  class="spinner"
                  *ngIf="isInProgress"></i>
                {{ t('registration.user.register') }}
              </button>
            </div>
          </form>

          <div
            class="register-user_request-email-form-hint"
            [innerHTML]="
              t('registration.user.form-hint', {
                termsLink: '/legal-terms/terms-of-use',
                privacyLink: '/legal-terms/privacy-policy',
                cookiesLink: cookiesLink
              })
            "></div>
        </div>
      </div>
    </div>

    <div class="landing_content invitation-link_content">
      <div class="invitation-link_benefits">
        <h2 class="invitation-link_content_heading">{{ t('registration.user.benefits.title') }}</h2>
        <p class="invitation-link_content_caption">{{ t('registration.user.benefits.caption') }}</p>
        <div class="invitation-link_benefits_cols">
          <div class="invitation-link_benefits_col">
            <app-icon name="team"></app-icon>
            <h3>{{ t('registration.user.benefits.col1.title') }}</h3>
            {{ t('registration.user.benefits.col1.caption') }}
          </div>
          <div class="invitation-link_benefits_col">
            <app-icon name="recommend"></app-icon>
            <h3>{{ t('registration.user.benefits.col3.title') }}</h3>
            {{ t('registration.user.benefits.col3.caption') }}
          </div>
          <div class="invitation-link_benefits_col">
            <app-icon name="be-rewarded"></app-icon>
            <h3>{{ t('registration.user.benefits.col2.title') }}</h3>
            {{ t('registration.user.benefits.col2.caption') }}
          </div>
        </div>
      </div>

      <div class="invitation-link_steps">
        <h2 class="invitation-link_content_heading">{{ t('registration.user.steps.title') }}</h2>
        <div class="invitation-link_steps_cols">
          <div class="invitation-link_steps_col">
            <div class="invitation-link_steps_col_index">1</div>
            <h3>{{ t('registration.user.steps.col1.title') }}</h3>
            <span [innerHTML]="t('registration.user.steps.col1.caption', { company: companyName })"></span>
            <div class="invitation-link_steps_col_after">
              <div class="invitation-link_steps_col_after_caption">{{ t('registration.user.steps.col1.hint') }}</div>
            </div>
          </div>
          <div class="invitation-link_steps_col">
            <div class="invitation-link_steps_col_index">2</div>
            <h3>{{ t('registration.user.steps.col2.title') }}</h3>
            <span>{{ t('registration.user.steps.col2.caption') }}</span>
            <div class="invitation-link_steps_col_after">
              <div class="invitation-link_steps_col_after_caption">{{ t('registration.user.steps.col2.hint') }}</div>
            </div>
          </div>
          <div class="invitation-link_steps_col">
            <div class="invitation-link_steps_col_index">3</div>
            <h3>{{ t('registration.user.steps.col3.title') }}</h3>
            <span>{{ t('registration.user.steps.col3.caption') }}</span>
            <div class="invitation-link_steps_col_after">
              <div class="invitation-link_steps_col_after_caption">{{ t('registration.user.steps.col3.hint') }}</div>
            </div>
          </div>
        </div>
      </div>

      <div class="invitation-link_apps">
        <h2 class="invitation-link_content_heading">{{ t('registration.user.apps.title') }}</h2>
        <app-mobile-apps-badges></app-mobile-apps-badges>
      </div>
    </div>
  </div>
</ng-container>
<ng-template #loaderBlock>
  <app-icon
    class="layout_spinner"
    name="spinner"></app-icon>
</ng-template>
